import React, {useState} from 'react';
import { trainingTooltips } from "../../../componentObjects";
import IconTooltip from '@mui/material/Tooltip';
import OnboardingDashboardCard from './OnboardingDashboardCard';


function AssetStatesRow(props) {
    const { title, assetStateCounts, onAssetsNeedTrainingClick, onAssetStateClick } = props;

    let assetsNeedTrainContent = <div className="row no-gutters card-row text-center">
            <div className="col min-height-40 border-right">
                <div className="row no-gutters dashboard-val justify-content-center" onClick={() => onAssetStateClick('new')}>
                    <IconTooltip  placement="top" title={trainingTooltips?.new}
                                                enterDelay={600} leaveDelay={200} >
                        <div className="col">
                            <div className="dashboard-number db-num3" >
                                {assetStateCounts?.new}
                            </div>
                        </div>
                    </IconTooltip>
                </div>
                <div>
                    <small className={"color-dimgray font-size-80p text-center"}>New</small>
                </div>
            </div>

            <div className="col min-height-40 border-right">
                <div className="row no-gutters dashboard-val justify-content-center" onClick={() => onAssetStateClick('awaitingData')}>
                    <IconTooltip  placement="top" title={trainingTooltips?.awaitingData}
                                                enterDelay={600} leaveDelay={200} >
                        <div className="col text-center">
                            <div className="dashboard-number db-num3">
                                {assetStateCounts?.awaitingData}
                            </div>
                        </div>
                    </IconTooltip>
                </div>
                <div>
                    <small className={"color-dimgray font-size-80p text-center"}>Awaiting Data</small>
                </div>
            </div>

            <div className="col min-height-40 border-right">
                <div className="row no-gutters dashboard-val justify-content-center" onClick={() => onAssetStateClick('training')}>
                    <IconTooltip  placement="top" title={trainingTooltips?.training}
                                                enterDelay={600} leaveDelay={200} >
                        <div className="col text-center">
                            <div className="dashboard-number db-num3">
                                {assetStateCounts?.training}
                            </div>
                        </div>
                    </IconTooltip>
                </div>
                <div>
                    <small className={"color-dimgray font-size-80p text-center"}>Training</small>
                </div>
            </div>

            <div className="col min-height-40 border-right">
                <div className="row no-gutters dashboard-val justify-content-center" onClick={() => onAssetStateClick('trained')}>
                    <IconTooltip  placement="top" title={trainingTooltips?.trained}
                                                enterDelay={600} leaveDelay={200} >
                        <div className="col text-center" >
                            <div className="dashboard-number db-num3">
                                {assetStateCounts?.trained}
                            </div>
                        </div>
                    </IconTooltip>
                </div>
                <div>
                    <small className={"color-dimgray font-size-80p text-center"}>Trained</small>
                </div>
            </div>

            <div className="col min-height-40 border-right">
                <div className="row no-gutters dashboard-val justify-content-center" onClick={() => onAssetStateClick('operational')}>
                    <IconTooltip  placement="top" title={trainingTooltips?.operational}
                                                enterDelay={600} leaveDelay={200} >
                        <div className="col text-center">
                            <div className="dashboard-number db-num3">
                                {assetStateCounts?.operational}
                            </div>
                        </div>
                    </IconTooltip>
                </div>
                <div>
                    <small className={"color-dimgray font-size-80p text-center"}>Operational</small>
                </div>
            </div>

            <div className="col min-height-40 border-right">
                <div className="row no-gutters dashboard-val justify-content-center" onClick={() => onAssetStateClick('reprovision')}>
                    <IconTooltip  placement="top" title={trainingTooltips?.reprovision}
                                                enterDelay={600} leaveDelay={200} >
                        <div className="col text-center">
                            <div className="dashboard-number db-num3">
                                {assetStateCounts?.reprovision}
                            </div>
                        </div>
                    </IconTooltip>
                </div>
                <div>
                    <small className={"color-dimgray font-size-80p text-center"}>Reprovision</small>
                </div>
            </div>

            <div className="col min-height-40">
                <div className="row no-gutters dashboard-val justify-content-center" onClick={() => onAssetStateClick('retrain')}>
                    <IconTooltip  placement="top" title={trainingTooltips?.retrain}
                                                enterDelay={600} leaveDelay={200} >
                        <div className="col text-center">
                            <div className="dashboard-number db-num3">
                                {assetStateCounts?.retrain}
                            </div>
                        </div>
                    </IconTooltip>
                </div>
                <div>
                    <small className={"color-dimgray font-size-80p text-center"}>Retrain</small>
                </div>
            </div>
        </div>;

    return (
        <div className="row pad-30-30-0">
            <div className="col display-grid">
                <OnboardingDashboardCard title={title} content={assetsNeedTrainContent} onClick={onAssetsNeedTrainingClick} isGraphCard={false}/>
            </div>
        </div>
    );
}

export default AssetStatesRow;